if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          this.cart.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateVariantInput() {
    const input = this.closest('form').querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class BundleRadios extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form');
    this.radioFieldsets = this.form.querySelectorAll('fieldset');
    this.radioContainers = this.form.querySelectorAll('variant-radios fieldset');
    this.availableSizes = this.setAvailability();
    this.newFieldset = this.setupFieldset();
    
    this.populateFieldset();
    this.setInitial();
    this.appendFieldset();
    this.addClickListener();
  }

  setupFieldset() {
    const clonedFieldset = this.radioFieldsets[0].cloneNode();
    const clonedInputs = clonedFieldset.querySelectorAll('input');
    const clonedLabels = clonedFieldset.querySelectorAll('label');
    clonedFieldset.classList.add('bundle-fieldset');

    clonedInputs.forEach((input, index) => {
      const id = `${this.id}-${index}`;
      input.id = id;
      clonedLabels[index].setAttribute('for', id)
    })

    return clonedFieldset;
  }

  setAvailability() {
    const fieldsetArray = Array.from(this.radioFieldsets);
    
    const optionSizes = fieldsetArray.map(fieldset => {
      return Array.from(fieldset.querySelectorAll('input')).map(input => {
        return {
          value: input.value,
          available: !input.classList.contains('disabled')
        };
      });
    });
    
    const bundleSizes = this.setBundleSizes(optionSizes);
    return bundleSizes;
  }

  setBundleSizes(optionSizes) {
    const sizeAvailability = {};

    // Iterate through each option set
    optionSizes.forEach(optionSet => {
      optionSet.forEach(sizeOption => {
        const { value, available } = sizeOption;
        
        // Initialize or update the availability of the size
        if (sizeAvailability[value] === undefined) {
          sizeAvailability[value] = available;
        } else {
          // Ensure the size is marked available only if it's available in all option sets
          sizeAvailability[value] = sizeAvailability[value] && available;
        }
      });
    });

    // Convert the result object into the desired array format
    const resultArray = Object.keys(sizeAvailability).map(value => ({
      value,
      available: sizeAvailability[value]
    }));

    return resultArray;
  }

  populateFieldset() {
    this.availableSizes.forEach(size => {
      const label = this.createLabel(size.value);
      const input = this.createInput({ size: size.value, available: size.available });
      this.newFieldset.append(input);
      this.newFieldset.append(label);
    })
  }

  createLabel(size) {
    const labelTemplate = this.radioFieldsets[0].querySelector('label');
    const label = document.createElement('label');
    label.setAttribute('for', `${this.id}-${size}`);
    label.setAttribute('value', size);

    // Create label content
    const labelContent = document.createElement('span');
    const content = document.createTextNode(size);
    labelContent.appendChild(content);
    label.appendChild(labelContent);

    // Create classes
    const classList = Array.from(labelTemplate.classList);
    classList.forEach(newClass => label.classList.add(newClass));

    return label;
  }

  createInput({ size, available }) {
    const inputTemplate = this.radioFieldsets[0].querySelector('input');
    const input = document.createElement('input');
    input.setAttribute('type', 'radio');
    input.setAttribute('name', 'Bundled Orthotic Insole (Size)');
    input.setAttribute('value', size);
    input.setAttribute('form', this.form.getAttribute('id'));
    input.setAttribute('id', `${this.id}-${size}`);

    // Create classes
    const classList = Array.from(inputTemplate.classList).filter(item => item != 'disabled');
    classList.forEach(newClass => input.classList.add(newClass));
    if (!available) {
      input.classList.add('disabled');
      input.setAttribute('disabled', '')
    }    

    return input;
  }

  setInitial() {
    const newInputs = this.newFieldset.querySelectorAll('input');

    for (const input of newInputs) {
      if (!input.classList.contains('disabled')) {
        input.setAttribute('checked', '');
        const value = input.value;
        this.setRadioChecked(value);
        return;
      }
    }
  }

  appendFieldset() {
    this.append(this.newFieldset);
  }

  addClickListener() {
    const labels = this.form.querySelector('.bundle-fieldset').querySelectorAll('label');

    labels.forEach(label => {
      const value = label.getAttribute('value');
      label.addEventListener('click', () => {
        this.setRadioChecked(value)
      })
    })
  }

  setRadioChecked(value) {
    this.radioContainers.forEach(container => {
      const label = container.querySelector(`label[data-value="${value}"]`)
      label.click();
    })
  }
}

customElements.define('bundle-radios', BundleRadios);
